<template>
<div>
     <template v-if="compId == 1">
          <v-data-table v-if="!isLoading" :search="search" :single-select="singleSelect" v-model="selected" show-select :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }" :headers="headers" class="elevation-1 mt-0 px-5" :items=" result " :height="inerHeight">

               <template v-slot:top>
                    <v-toolbar flat color="white" v-if="idPage == 1">
                         <v-spacer></v-spacer>

                         <v-autocomplete class="ma-4 mt-11" :items="signature" clearable dense v-model="filters.signature" :label="$t('signature')" :item-text="localLang=='fr' ? 'signature' : 'signatureAr'" item-value="id" outlined></v-autocomplete>

                         <v-autocomplete class="ma-4 mt-11" :items="isView" clearable dense v-model="filters.isView" :label="$t('isView')" :item-text="localLang=='fr' ? 'isView' : 'isViewAr'" item-value="id" outlined></v-autocomplete>

                         <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="10" transition="scale-transition" offset-y min-width="240px">
                              <template v-slot:activator="{ on }">
                                   <v-text-field class="ma-4" @click:clear="clirtext" dense hide-details outlined v-model="dateRangeText" :label="$t('dateDF')" clearable readonly v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="filters.date_env" range></v-date-picker>
                         </v-menu>

                         <!-- <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                   <v-btn @click="signeMulti" v-on="on" class="ma-2" hide-details tile color="success">
                                        <v-icon color="" size="30">mdi-draw</v-icon>
                                   </v-btn>
                              </template>
                              <span>{{ $t('signeMulti') }}</span>
                         </v-tooltip> -->

                         <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                   <v-btn @click="deleteMulti" v-on="on" class="ma-2" hide-details tile color="red">
                                        <v-icon color="white" size="30">mdi-delete-sweep</v-icon>
                                   </v-btn>
                              </template>
                              <span>{{ $t('deleteMulti') }}</span>
                         </v-tooltip>

                    </v-toolbar>

                    <v-toolbar flat color="white" v-else>

                         <v-text-field :label="$t('search')" v-model="search" hide-details dense outlined></v-text-field>

                         <v-spacer></v-spacer>
                         <v-tooltip v-if="idPage == 2" bottom>
                              <template v-slot:activator="{ on }">
                                   <v-btn @click="addNewCartFidaliti" v-on="on" class="ma-2" hide-details tile color="success">
                                        <v-icon color="white" size="30">mdi-plus</v-icon>
                                   </v-btn>
                              </template>
                              <span>{{ $t('addCartFidaliti') }}</span>
                         </v-tooltip>

                         <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                   <v-btn @click="deleteMultiCartFidaliti" v-on="on" class="ma-2" hide-details tile color="red">
                                        <v-icon color="white" size="30">mdi-delete-sweep</v-icon>
                                   </v-btn>
                              </template>
                              <span>{{ $t('deleteMulti') }}</span>
                         </v-tooltip>
                    </v-toolbar>
               </template>

               <template v-slot:item.date_env="{ item }">
                    <v-chip dark color="blue lighten-2">{{ item.date_env  }}</v-chip>
               </template>

               <template v-slot:item.file="{ item }">
                    <span @click="showPDF(item)" class="btnShowModal">{{ item.file }}</span>
               </template>

               <template v-slot:item.signature="{ item }">
                    <v-chip color="orange lighten-0" dark v-if="item.signature == 0">{{ $t('noSign') }}</v-chip>
                    <v-chip color="green lighten-1" dark="" v-else>{{ $t('signe') }}</v-chip>
               </template>
               <template v-slot:item.isView="{ item }">
                    <v-chip color="green lighten-0" dark v-if="item.isView == 1">
                         <v-icon>mdi-eye</v-icon>
                    </v-chip>
                    <v-chip color="red lighten-1" dark v-else>
                         <v-icon>mdi-eye-off</v-icon>
                    </v-chip>
               </template>

               <template v-slot:item.action="{ item }">

                    <v-tooltip bottom v-if="idPage == 2">
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon color="orange" @click="updateCartFidaliti(item)">
                                   <v-icon size="30"> mdi-update </v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('update') }}</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="idPage == 3">
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon color="success" @click="openCartFidalitiModal(item)">
                                   <v-icon size=30>mdi-registered-trademark </v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('response') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="idPage == 3">
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon color="orange" @click="openCartFidalitiDetails(item)">
                                   <v-icon size=30>mdi-details </v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('details') }}</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="idPage == 1">
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon color="red" @click="removeItem(item)">
                                   <v-icon size=30>mdi-delete-outline </v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('supprimer') }}</span>
                    </v-tooltip>

                    <v-tooltip bottom v-else>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon color="red" @click="deleteCartFidaliti(item)">
                                   <v-icon size=30>mdi-delete-outline </v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('supprimer') }}</span>
                    </v-tooltip>

               </template>

          </v-data-table>

          <v-skeleton-loader v-else ref="skeleton" type="table"></v-skeleton-loader>

     </template>

     <v-dialog class="" v-model="dialog15" max-width="700">
          <v-card>
               <v-card-title class="headline ">{{ $t('voResult') }}</v-card-title>
               <v-card-text>
                    <iframe :src="nLabo + '/result/'+infoPdf.file | URL2" width="100%" height="600"></iframe>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog15 = false">{{ $t('close') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>

     <v-dialog v-model="dialog2" persistent max-width="400">
          <v-card>
               <v-card-title class="headline">
                    {{ isUpdate ? $t('updateCartFidaliti') : $t('addCartFidaliti') }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="error" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12">
                              <v-text-field hide-details v-model="form.nom_complet" dense :label="$t('fullname')" outlined></v-text-field>
                         </v-col>
                         <v-col cols="12">
                              <v-text-field hide-details dense v-model="form.nip" :label="$t('nip')" outlined></v-text-field>
                         </v-col>
                         <v-col cols="12">
                              <v-text-field hide-details dense v-model="form.password" :label="$t('password')" outlined></v-text-field>
                         </v-col>
                    </v-row>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!isLoad" color="green darken-1" text @click="saveCartFidaliti">
                         {{ $t('save') }}
                    </v-btn> 
               </v-card-actions>
          </v-card>
     </v-dialog>
     <v-dialog v-model="dialog20" persistent max-width="400">
          <v-card>
               <v-card-title class="headline">
                    {{ $t('details')  }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="error" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12">
                              <span hide-details dense :label="$t('fullname')" outlined>{{ form.nom_complet }}</span>
                         </v-col>
                         <v-col cols="12">
                              <span hide-details dense :label="$t('email')" outlined>{{ form.email }}</span>
                         </v-col>
                         <v-col cols="12">
                              <span hide-details dense :label="$t('phone')" outlined>{{ form.telephone }}</span>
                         </v-col>
                         <v-col cols="12">
                              <span hide-details dense :label="$t('description')" outlined>{{ form.description }}</span>
                         </v-col>
                    </v-row>
               </v-card-text> 
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {

     data: () => ({
          menu2: false,
          isUpdate: false,
          idPage: 1,
          dialog2: false,
          dialog20: false,
          signature: [{
                    id: 0,
                    signature: 'Non signé',
                    signatureAr: 'لم توقع بعد',
               },
               {
                    id: 1,
                    signature: 'signé',
                    signatureAr: 'موقع',
               }
          ],
          isView: [{
                    id: 0,
                    isView: 'Non vue',
                    isViewAr: 'لم يتم رؤيتها',
               },
               {
                    id: 1,
                    isView: 'Vue',
                    isViewAr: 'تم رؤيتها',
               },
          ],
          filters: {
               date_env: [],
               signature: '',
               isView: '',
          },
          compId: 1,
          infoPdf: {},
          form: {},
          nLabo: localStorage.getItem('DSHUZDPSDSPDSJSU4'),
          dialog15: false,
          isLoad: false,
          search: '',
          singleSelect: false,
          selected: [],
          headers: [{
                    text: localStorage.getItem('lang') == 'fr' ? 'Numéro' : 'الرقم',
                    value: 'password',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Le nom' : 'الإسم',
                    value: 'username',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Fichier PDF' : 'ملف PDF',
                    value: 'file',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Date' : 'بتاريخ',
                    value: 'date_env',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Vue' : 'رؤية',
                    value: 'isView',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Signature' : 'التوقيع',
                    value: 'signature',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'إجراء',
                    value: 'action',
                    align: 'center',
                    sortable: false
               },
          ],
          inerHeight: window.innerHeight - 270
     }),
     methods: {
          init() {
               this.form = {
                    nom_complet: '',
                    nip: '',
                    password: '',
                    email: '',
                    telephone: '',
                    description: '',
                    domainName: document.location.origin
               }
          },
          signez(item) {
               this.$store.dispatch('signePDF', {
                    data: JSON.stringify(item)
               })
               this.$store.dispatch('getResult')
          },
          removeItem(item) {
               this.$store.dispatch('deleteResult', {
                    data: JSON.stringify(item)
               })
               this.$store.dispatch('getResult')
          },
          signeMulti() {
               this.$store.dispatch('signePDF', {
                    data: JSON.stringify(this.selected)
               }).then((e) => {
                    this.selected = []
               })
               this.$store.dispatch('getResult')
          },
          addNewCartFidaliti() {
               this.isUpdate = false
               this.init()
               this.dialog2 = true
          },
          openCartFidalitiModal(item) {
               this.form = item
               this.dialog2 = true
          },
          openCartFidalitiDetails(item) {
               this.form = item
               this.dialog20 = true
          },
          deleteMultiCartFidaliti() {
               this.$store.dispatch('deleteCartFidaliti', {
                    data: JSON.stringify(this.selected)
               })
          },
          deleteCartFidaliti(item) {
               this.$store.dispatch('deleteCartFidaliti', {
                    data: JSON.stringify(item)
               })
          },
          updateCartFidaliti(data) {
               this.isUpdate = true
               this.form = data
               this.dialog2 = true
          },
          saveCartFidaliti() {
               this.isLoad = 0
               this.$store.dispatch('saveCartFidaliti', {
                    data: JSON.stringify(this.form)
               }).then(res => { 
                    this.isLoad = false
                    this.dialog2 = false
               }, () => {
                    this.isLoad = false
               })

          },
          close() {
               this.dialog2 = false
               this.dialog20 = false
          },
          deleteMulti() {
               this.$store.dispatch('deleteResult', {
                    data: JSON.stringify(this.selected)
               })
               // this.selected = []
          },
          showPDF(item) {
               this.dialog15 = true
               this.infoPdf = {},
                    this.infoPdf = item
          },
          clirtext(e) {
               this.filters.date_env = ['', '']
          },
     },
     computed: {
          dateRangeText() {
               return this.filters.date_env.join(' ~ ')
          },
          result() {
               if (this.idPage == 1) {
                    return new this.$MultiFilter(this.$store.state.result, this.filters).filterData()
               } else if (this.idPage == 2) {
                    return this.$store.state.cartFidaliti.filter(e => e.isDemand == 0)
               } else {
                    return this.$store.state.cartFidaliti.filter(e => e.isDemand == 1)
               }
          },
          cartFidaliti() {

          },
          isLoading() {
               return this.$store.state.isLoadings
          }

     },
     created() {
          this.init()
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.$store.dispatch('getCartFidaliti')
          Fire.$on('search', (search) => {
               this.search = search
          })
          window.addEventListener('resize', () => {
               this.inerHeight = window.innerHeight - 270
          })
          // Fire.$on('changeComponent', (Null, compId) => {
          //      this.compId = compId
          //      if (this.compId == 1) {
          //           this.headers = []
          //           this.headers.push({
          //                text: this.localLang == 'fr' ? 'Numéro' : 'الرقم',
          //                value: 'password',
          //                align: 'center',
          //                sortable: false
          //           }, {
          //                text: this.localLang == 'fr' ? 'Le nom' : 'الإسم',
          //                value: 'username',
          //                align: 'center',
          //                sortable: false
          //           }, {
          //                text: this.localLang == 'fr' ? 'Fichier PDF' : 'ملف PDF',
          //                value: 'file',
          //                align: 'center',
          //                sortable: false
          //           }, {
          //                text: this.localLang == 'fr' ? 'Date' : 'بتاريخ',
          //                value: 'date_env',
          //                align: 'center',
          //                sortable: false
          //           }, {
          //                text: this.localLang == 'fr' ? 'Vue' : 'رؤية',
          //                value: 'isView',
          //                align: 'center',
          //                sortable: false
          //           }, {
          //                text: this.localLang == 'fr' ? 'Signature' : 'التوقيع',
          //                value: 'signature',
          //                align: 'center',
          //                sortable: false
          //           }, {
          //                text: this.localLang == 'fr' ? 'Action' : 'إجراء',
          //                value: 'action',
          //                align: 'center',
          //                sortable: false
          //           }, )
          //      }
          // })

          Fire.$on('changeComponent2', idPage => {
               this.idPage = idPage
               if (this.idPage == 1) {
                    this.headers = [{
                              text: localStorage.getItem('lang') == 'fr' ? 'Numéro' : 'الرقم',
                              value: 'password',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Le nom' : 'الإسم',
                              value: 'username',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Fichier PDF' : 'ملف PDF',
                              value: 'file',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Date' : 'بتاريخ',
                              value: 'date_env',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Vue' : 'رؤية',
                              value: 'isView',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Signature' : 'التوقيع',
                              value: 'signature',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'إجراء',
                              value: 'action',
                              align: 'center',
                              sortable: false
                         },
                    ]
               } else if (this.idPage == 2) {
                    this.headers = [{
                              text: localStorage.getItem('lang') == 'fr' ? 'Nom complet' : 'الإسم الكامل',
                              value: 'nom_complet',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'NIP' : 'NIP',
                              value: 'nip',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Mote de passe' : 'كلمة السر',
                              value: 'password',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'إجراء',
                              value: 'action',
                              align: 'center',
                              sortable: false
                         },
                    ]
               } else {
                    this.headers = [{
                              text: localStorage.getItem('lang') == 'fr' ? 'Nom complet' : 'الإسم الكامل',
                              value: 'nom_complet',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'E-mail' : 'البريد الإلكتروني',
                              value: 'email',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Téléphone' : 'الهاتف',
                              value: 'telephone',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Date' : 'تاريخ الإرسال',
                              value: 'created_at',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'إجراء',
                              value: 'action',
                              align: 'center',
                              sortable: false
                         },
                    ]
               }
          })
     }
}
</script>

<style scoped>
</style><style>
.btnShowModal {
     cursor: pointer;
     margin-left: 5px;
     font-weight: 700;
     background: transparent;
     color: blue;
}

.v-dialog:not(.v-dialog--fullscreen) {
     max-height: 86%;
}
</style>
